// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"3309c4f3","24":"dd9544a6","95":"57adb7ea","194":"dd9544a6","268":"341672a5","452":"6e8f84f4","472":"e5e66d4a","505":"0f4483ad","747":"fac1eaa4","810":"04352be0","862":"296edad4"}[chunkId] + ".chunk.css";
};